export default __webpack_public_path__ + "static/features-hero-bg-428af2d5c737af2aa86f057f0486b591.png";